/*
================================================================
         Copyright (c) 2018-2022 Digitize Things Inc.
                     All rights reserved.
================================================================
*/

import React from "react";
import Catalog from "../pages/sales/catalog/catalog";
import Product from "../pages/sales/product/product";
import SubscriptionAdjustments from "../pages/sales/subscriptionAdjustments/subscriptionAdjustments";
import SubscriptionAdjustment from "../pages/sales/subscriptionAdjustment/subscriptionAdjustment";
import NewAdjustment from "../pages/sales/subscriptionAdjustments/newAdjustments";
import Cart from "../pages/sales/cart/cart";
import Checkout from "../pages/sales/checkout/checkout";
import Orders from "../pages/sales/orders/orders";
import Order from "../pages/sales/order/order";
import Subscriptions from "../pages/sales/subscriptions/subsciptions";
//import ProductSpecification from '../pages/pm/component/specification/productSpecification';
import ProductSpecification from "../pages/pm/component/specification/productSpecificationTreeView";
import ProductCharacteristics from "../pages/pm/component/specification/productCharacteristics";
// Imported from pmui
import CreateProvider from "../pages/pm/provider/provider";
import CreatePackage from "../pages/pm/packagedSolution/createPackage";
import PackagedSolutionList from "../pages/pm/packagedSolutionList/packagedSolutionList";
import CreateSpecialPrice from "../pages/pm/createPackage/createSpecialPrice/createSpecialPrice";

import ManageCustomers from "../pages/sales/manageCustomers/manageCustomers";

import ProviderProfile from "../pages/pm/provider/providerProfile";
import ProviderContracts from "../pages/pm/provider/providerContracts";
import ViewContract from "../pages/pm/provider/viewContract";
import BillingHistory from "../pages/sales/reports/billing/billingHistory";
import Settlement from "../pages/sales/reports/settlement/settlement";
import SolutionsContracts from "../pages/pm/provider/solutionContracts";
import ViewPackage from "../pages/pm/viewPackage/viewPackage";
import ComponentProduct from "../pages/pm/component/componentProduct";
import Activation from "../pages/sales/activation/activation";
import CustomerProfile from "../pages/pm/customer/profile";
import Stats from "../pages/sales/stats/stats";
import OrderReport from "../pages/sales/reports/order/orderReport";
import Billing from "../pages/sales/reports/billing/billing";
import DashboardReports from "../pages/sales/reports/dashboard/dashboardReports";

// From Kore
import AssetOwnershipReport from "../pages/sales/reports/asset/assetOwnershipReport";
import ReturnAndExchange from "../pages/sales/order/returnAndExchange";
import InventoryReport from "../pages/sales/reports/inventory/inventoryReport";
import InventoryReceiveReport from "../pages/sales/reports/inventory/inventoryReceiveReport";
import WorkOrderReport from "../pages/sales/reports/order/workOrderReport";
import PaymentReport from "../pages/sales/reports/payment/paymentReport";
import GenericReports from "../pages/sales/genericReports/reports";

// Admin routes
import Admin from "../pages/admin/admin";
import ManageSalesChannels from "../pages/admin/manageSalesChannels";
import ManageSolutionProviders from "../pages/admin/manageSolutionProviders";
import UpdatePackage from "../pages/pm/packagedSolution/createPackage";
import ManageServiceProviders from "../pages/admin/manageServiceProviders";

// Update order routes
import UpdateOrderContact from "../pages/sales/updateOrderContact/updateOrderContact";

import ProductOfferingRules from "../pages/pm/productOfferingRules/productOfferingRules";
import ReceivingRules from "../pages/pm/productOfferingRules/receivingRules";
import Quotes from "../pages/sales/quotes/quotes";
import IFRSReport from "../pages/sales/reports/ifrsReport/ifrsReport";

const routes = new Map([
  ["/:provider/contracts", SolutionsContracts],
  ["/:provider/contracts/:contractId", ViewContract],
  ["/activate/:id", Activation],
  ["/adjustments", NewAdjustment],
  ["/asset", AssetOwnershipReport],
  ["/availableOfferings", PackagedSolutionList],
  ["/billing", Billing],
  ["/billingRecords", BillingHistory],
  ["/cart", Cart],
  ["/catalog", Catalog],
  ["/changeOrder", Catalog],
  ["/changeOrder/:id", Product],
  ["/checkout", Checkout],
  ["/contracts", ProviderContracts],
  ["/contract/:contractId", ViewContract],
  ["/contract/:id/:contractId", ViewContract],
  ["/createPackage", CreatePackage],
  ["/createSpecialPrice", CreateSpecialPrice],
  ["/dashboard", Admin],
  ["/dashboard", DashboardReports],
  ["/editPackage", PackagedSolutionList],
  ["/inventoryReceiptReport", InventoryReceiveReport],
  ["/inventoryReport", InventoryReport],
  ["/manageCustomers", ManageCustomers],
  ["/manageLeads", ManageCustomers],
  ["/manageSalesChannels", ManageSalesChannels],
  ["/manageServiceProviders", ManageServiceProviders],
  ["/manageSolutionProviders", ManageSolutionProviders],
  ["/myOfferings", PackagedSolutionList],
  ["/myProfile", CustomerProfile],
  ["/newOrder", Catalog],
  ["/newOrder/:id", Product],
  ["/order/:orderId", Order],
  ["/orderReport", OrderReport],
  ["/orders", Orders],
  ["/specification", ProductSpecification],
  ["/characteristic", ProductCharacteristics],
  ["/paymentReport", PaymentReport],
  ["/product", Catalog],
  ["/product/:id", Product],
  ["/productOfferingRules", ProductOfferingRules],
  ["/products", ComponentProduct],
  ["/profile", ProviderProfile],
  ["/providers/:providerType", CreateProvider],
  ["/quote", Cart],
  ["/quotes", Quotes],
  ["/receivingRules", ReceivingRules],
  ["/report/:reportName", GenericReports],
  ["/return/:id", ReturnAndExchange],
  ["/settlement", Settlement],
  ["/stats", Stats],
  ["/subscriptions", Subscriptions],
  ["/subscriptionAdjustments", SubscriptionAdjustments],
  [
    "/subscriptionAdjustments/:subscriptionAdjustmentId",
    SubscriptionAdjustment,
  ],
  ["/updatePackage", UpdatePackage],
  ["/viewProduct/:id", ViewPackage], // to view packaged solution catalog details
  ["/workOrders", WorkOrderReport],
  ["/ifrsReport", IFRSReport],
]);

const orderRoutes = new Map([
  ["/order/:orderId/product", Catalog],
  ["/order/:orderId/product/:id", Product],
  ["/order/:orderId/contact", UpdateOrderContact],
]);

export default { routes: routes, orderRoutes: orderRoutes };
